/* ROHHカスタム: スウォッチ選択に合わせて「カラー：◯◯」の表示を更新 */
(function () {
  function updateSelectedValue(container) {
    if (!container) return;

    const fieldsets = container.querySelectorAll('fieldset');
    fieldsets.forEach((fs) => {
      const valueEl = fs.querySelector('[data-rohh-selected-value]');
      if (!valueEl) return;

      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) {
        valueEl.textContent = checked.value;
        return;
      }

      const select = fs.querySelector('select');
      if (select) valueEl.textContent = select.value;
    });
  }

  document.addEventListener('change', (e) => {
    const container =
      e.target.closest('variant-radios') ||
      e.target.closest('variant-selects') ||
      e.target.closest('product-form');

    updateSelectedValue(container);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('variant-radios, variant-selects, product-form')
      .forEach((c) => updateSelectedValue(c));
  });
})();
